<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form
            :inline="true"
            :model="searchForm"
            :rules="searchRules"
            ref="searchForRef"
            label-width="100px"
            autocomplete="on"
            size="mini"
          >
            <el-form-item >
              <el-input placeholder="请选择商家" v-model="searchForm.shop_name" :readonly="true"  @click.native="showShop" clearable type="text">
                <i slot="suffix" class="el-icon-more"></i>
              </el-input>
            </el-form-item>
            <!-- <el-form-item label="角色名称">
              <el-input v-model="searchForm.role_name" type="text" name="role_name"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="状态">
              <el-select
                v-model="searchForm.status"
                placeholder="请选择状态"
              >
                <el-option label="全部" :value="0"></el-option>
                <el-option label="开启" :value="1"></el-option>
                <el-option label="禁用" :value="2"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item>
              <el-button type="success" @click="searchSubmit">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button  type="primary" @click="addData">新增</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <!-- 表格 -->
      <el-table
        border
        :data="tableLoadData"
        style="width: 100%; margin-top:20px"
        row-key="id"
        :tree-props="{children: 'children'}"
        size="mini"
      >
        <el-table-column prop="name" label="菜单名称" width="180"></el-table-column>
<!--        <el-table-column prop="url" label="地址" width="180"></el-table-column>-->
        <el-table-column prop="path" label="路径" width="300"></el-table-column>
        <el-table-column prop="pid" label="父级ID" width="100"></el-table-column>
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column
          prop="level"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size='mini' @click="handelEdit(scope.row)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size='mini' @click="removeRole(scope.row.id)" >删除</el-button>
            <!-- <el-button type="warning" icon="el-icon-setting" size='small' @click="showRoleVisible(scope.row)">分配角色</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- <e-table :tableHeadConfig="tableHeadConfig" :tableLoadData="tableLoadData" style="margin-top:20px">
        <template v-slot:name="slotData">
          <span>{{slotData.data.row.name }}</span>
        </template>
        <template v-slot:operation="slotData">
          <el-button type="warning" size="mini" @click="handelEdit(slotData)"> 编辑{{slotData.data.row.level}}</el-button>
        </template>

      </e-table> -->
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="菜单名称">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="module_id">
          <el-input v-model="id" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="path地址">
          <el-input v-model="form.path" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="图标">
          <el-input v-model="form.icon" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="pid">
          <!-- <el-input v-model="form.pid" placeholder="所属的pid"></el-input> -->
          <!-- <el-cascader :options="roleList" v-model="AppListId" collapse-tags :props="props" @change="getRoleId" :show-all-levels="false"></el-cascader> -->

          <el-cascader v-model="form.pid"
                       style="width: 100%" ref="cascaderAddr"
                       @change="getval($event)"
                       :props="{ value: 'id',label: 'name',children: 'children',checkStrictly: true}"
                       :options="cateMenus"
                       clearable>

          </el-cascader>


          <!-- <el-cascader :options="roleList" :check-strictly="true" v-model="form.AppListId" :props="props" clearable @change="getRoleId" ref="cascaderRef"></el-cascader> -->
        </el-form-item>
        <!-- <el-form-item label="状态">
          <el-select
            v-model="form.status"
            placeholder="请选择状态"
          >
            <el-option label="开启" :value="1"></el-option>
            <el-option label="禁用" :value="2"></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="reset_dialogForm('form')">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

    <eShopList
      :formData="formData1"
      :visible.sync="visible1"
      :title="title1"
      :closeForm="closeForm1"
    />
  </div>
</template>

<script>
  import eShopList from "../../common/eShopList.vue";
  export default {
    name: "shopModuleList",
    components: {
      eShopList
    },
    data() {
      return {
        formData1:{},
        visible1:false,
        title1:'',

        cateMenus:[],
        // 搜索
        searchForm: {
          role_name: '',
          status: 0,
          shop_id:'',
          shop_name:''
        },
        searchRules: {
          role_name: [
            { required: true, message: "请输入管理员名称", trigger: "blur" },
          ],
        },

        // 数据
        tableLoadData: [],
        page:1,// 当前页码
        limit:10,// 每页大小
        total:0,//总条目数
        baseUrl:this.$store.state.defineWebURL,
        id: '',

        OrganizatioChooseList:[],
        value :'',
        //改变label
        cascader: {
          value: "id",
          label: "label",
          multiple: true,
          checkStrictly: true,
        },
        options: [{
          id: '1',
          name: '指南',
          children: [{
            id: '10',
            name: '设计原则',
            children:[{
              id: '66',
              name: 'ceshi2'
            },
              {
                id: '68',
                name: 'ceshi4'
              }]
          }, {
            id: '12',
            name: '导航'
          }]
        }, {
          id: '2',
          name: '组件',
          children: [{
            id: '20',
            name: 'Basic',
          }, {
            id: '21',
            name: 'Others',
          }]
        }],

        rules: {
          role_name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],

          role_id: [
            { required: true, message: '请选择角色', trigger: 'change' }
          ],
          status: [
            { required: true, message: '请选择状态', trigger: 'change' }
          ],
        },

        dialogFormVisible: false,
        title: '',
        form: {
          path:'',
          name: '',
          url: '',
          module_id: '',
          role_id: '',
          AppListId:[],
          icon:''
        },
        standardDocOrganizationData: []
        // module_id: ''
      };

    },
    created() {
      //this.roleDataAdd()
      this.getMenus();
    },
    mounted() {},
    filters: {
      statusFilter(status) {
        if (status == 1) {
          return "启用";
        } else if (status == 2) {
          return "禁用";
        }
      }
    },
    methods: {
      closeForm1(){
        this.title1="";
        console.log('this.formData1',this.formData1)
        this.searchForm.shop_id=this.formData1.id;
        this.searchForm.shop_name=this.formData1.name;

        this.visible1=false;
      },
      showShop(){
        this.title1="供应商";
        this.visible1=true;
      },
      getMenus(){
        let _this = this;
        let params={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
          shop_id:sessionStorage.getItem('shop_id'),
        };
        this.$axios.shopModuleFindTree(params).then((res)=>{
          if(res.code == 200) {
            _this.cateMenus=res.data;
          }else{
            _this.cateMenus=[]
          }
        });
        _this.submit=false;
      },
      getval() {
        let _this = this;
        //let checkval = [];
        const obj = this.$refs['cascaderAddr'].getCheckedNodes();
        _this.pid = obj[0].data.id;
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
       if(!this.searchForm.shop_id){
         this.$message.error("请选择商家");
         return;
       }
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          // uid:sessionStorage.getItem('uid'),
          // shop_id:this.searchForm.shop_id
        }
        // let roles=JSON.parse(sessionStorage.getItem('roles'));
        // let role_ids=[];
        // for(var i=0;i<roles.length;i++){
        //   role_ids.push(roles[i].id);
        // }
        // param.role_id=role_ids.join(',');

        this.$axios.getShopMoudleTree(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data
          }
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        console.log(newSize);
        this.limit = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.page = newPage
        console.log(newPage);
        this.DataList()
      },
      // 选择添加的角色
      roleDataAdd(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          uid:sessionStorage.getItem('uid'),
        }
        let roles=JSON.parse(sessionStorage.getItem('roles'));
        let role_ids=[];
        console.log('roles',roles)
        for(var i=0;i<roles.length;i++){
          console.log('id----',roles[i].id)
          role_ids.push(roles[i].id);
        }
        param.role_id=role_ids.join(',');

        this.$axios.companyModuleList(param).then(res=>{
          if(res.code == 200){
            var roleArr = [];
            (res.data).forEach(v  => {
              var con = {}; //二级内容
              var con_child=[]; //二级内容的child
              con.id = v.id;
              con.name = v.name;
              // console.log(v.children,888888888888);
              if(v.children != undefined ) {
                (v.children).forEach(v2  => {
                  var con2 = {}; //二级内容的child的内容
                  con2.id = v2.id;
                  con2.name = v2.name;
                  //con2.children = v2.actions;
                  con_child.push(con2);
                })
                con.children = con_child;
              }
              roleArr.push(con);
            });
            this.roleList = roleArr;
          } //code=200
        })
      },
      // 获取选中角色变化时的数据
      getRoleId(e){
        console.log(e,1212);
        // this.pid = e[1]?e[1]:e[0];
      },
      // 新增
      addData() {
        this.title = '新增'
        this.dialogFormVisible = true
      },
      handelEdit(index) {
        this.id = index.id
        this.form.name = index.name
        this.form.url = index.url;
        this.form.icon = index.icon;
        this.form.path = index.path;
        this.pid = index.pid
        this.title = '编辑'
        if(index.pid!=0){
          //this.form.pid=index.pid+'';
          // var pids=[999,99901];  // 一维当前数组的判断
          this.form.AppListId = index.pid;
          // this.form.AppListId=pids;
        }
        this.dialogFormVisible = true
        // this.form = {...row};

      },
      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.id){
              //  新增
              const para = {
                title: this.form.name,
                url: this.form.url,
                path: this.form.path,
                icon: this.form.icon,
                AppListId:this.form.AppListId,
                module_id: this.id,
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token')
              }
              if(this.form.AppListId&&this.form.AppListId.length>0){
                para.pid=  this.form.AppListId[this.form.AppListId.length-1];
              }else{
                para.pid=this.form.pid[0];
              }
              this.$axios.shopModuleSave(para).then(res =>{
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                title: this.form.name,
                url: this.form.url,
                path: this.form.path,
                pid: this.pid,
                module_id: this.id,
                icon: this.form.icon,
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token')
              }
              this.$axios.shopModuleSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },
      searchSubmit() {
        this.DataList();
      },
      OrganizatioChoose() {

      }

    },
  };
</script>
<style>

</style>

